import clamscan from "clamscan";

export default async function antivirusScan(filePath) {
  console.log(`Scanning file "${filePath}"`);
  try {
    const scanner = await new clamscan().init({
      remove_infected: true,
      debug_mode: process.env.NODE_ENV !== 'production',
      clamdscan: {
        socket: false, //process.env.CLAM_SOCKET, // Socket file for connecting via TCP
        host: process.env.CLAM_HOST, // IP of host to connect to TCP interface
        port: process.env.CLAM_PORT, // Port of host to use when connecting via TCP interface
        timeout: 60000, // Timeout for scanning files
        local_fallback: false, // Do no fail over to binary-method of scanning
        path: '/usr/bin/clamdscan', // Path to the clamdscan binary on your server
        config_file: null, // Specify config file if it's in an unusual place
        multiscan: true, // Scan using all available cores! Yay!
        reload_db: false, // If true, will re-load the DB on every call (slow)
        active: true, // If true, this module will consider using the clamdscan binary
        bypass_test: false, // Check to see if socket is available when applicable
      },
    });
    const {file, is_infected, viruses} = await scanner.scan_file(filePath);
    if (is_infected) {
      throw new Error(`FILE INFECTED! Viruses detected: ${viruses.join(', ')}`)
    } else {
      console.log(`File "${filePath}" is clean`);
    }
  }  catch (e) {
    if (!process.env.LOCAL) {
      throw e;
    } else {
      console.log('Skipping scan: ', e.message);
    }
  }
}